<template>
  <div class="changePassword" style="margin-top: 10px;width: 1440px;margin:0 auto;">
    <el-row justify="center" type="flex">
      <el-col  >
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane :label="editUserTab" name='addNewUser'>
            <el-form :model="changePasswordForm" ref="changePasswordForm" :rules="rules">
              <el-form-item label="User Name" prop="userName" :disabled="readOnly">
                <el-input v-model="changePasswordForm.userName" :disabled="readOnly"></el-input>
              </el-form-item>
              <el-form-item label="Old Password" prop="oldPassword" required>
                <el-input type="password" v-model="changePasswordForm.oldPassword" required autocomplete="off" placeholder="请输入旧密码"></el-input>
              </el-form-item>
              <el-form-item label="New Password" prop="newPassword" required>
                <el-input type="password" v-model="changePasswordForm.newPassword" maxlength="20"  required autocomplete="off" placeholder="8-20位包含数字、大小写字母"></el-input>
                <el-progress :percentage="passwordPercent" :format="passwordPercentFormat" :color="customColorMethod"></el-progress>
              </el-form-item>
              <el-form-item label="Confirm Password" prop="confirmPassword" required>
                <el-input type="password" v-model="changePasswordForm.confirmPassword" required autocomplete="off" placeholder="请确认新密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('changePasswordForm')">Save</el-button>
                <el-button @click="resetForm('changePasswordForm')">Reset</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
      name: "changePassword",
      data(){
          let validateNewPassword =(rule,value,callback) =>{
            if(value === ''){
              callback(new Error('Please enter the new password'))
              this.passwordPercent = 0;
            }else{
             //密码验证
              var ls = 0;
              if(this.changePasswordForm.newPassword !== ''){
                if(this.changePasswordForm.newPassword.match(/([a-z])+/)){
                  ls++;
                }
                if(this.changePasswordForm.newPassword.match(/([0-9])+/)){
                  ls++;
                }
                if(this.changePasswordForm.newPassword.match(/([A-Z])+/)){
                  ls++;
                }
                if(this.changePasswordForm.newPassword.match(/([\W])+/) && !this.changePasswordForm.newPassword.match(/(![\u4E00-\u9FA5])+/)){  
                  callback(new Error('不能包含特殊字符'));
                  ls=0;
                }
                if(this.changePasswordForm.newPassword.length < 8 || this.changePasswordForm.newPassword.length > 20 ){
                  callback(new Error('必须8-20位字符'));
                  ls=0;
                }
                if(this.changePasswordForm.newPassword.match(/([\u4E00-\u9FA5])+/)){
                  callback(new Error('不能包含中文字符'));
                  ls=0;
                }
                switch (ls) {
                  case 0: this.passwordPercent = 0;callback(new Error('必须包含数字、大小写字母'));break;
                  case 1: this.passwordPercent = 35;callback(new Error('必须包含数字、大小写字母'));break;
                  case 2: this.passwordPercent = 65;callback(new Error('必须包含数字、大小写字母'));break;
                  case 3: this.passwordPercent = 100;break;
                  //case 4: this.passwordPercent = 100;break;
                  default: this.passwordPercent = 0;break;
                }
              }
              callback();
            }
          }
          let validateConfirmPassword =(rule,value,callback) =>{
            if(value === ''){
              callback(new Error('Please enter the new password again'))
            }else if(value != this.changePasswordForm.newPassword){
              callback(new Error('The passwords entered twice are not same!'))
            }else{
              callback();
            }
          }
          return {
            readOnly:true,
            activeName:'addNewUser',
            editUserTab:'Change Password',
            changePasswordForm:{
              userName:'',
              oldPassword:'',
              newPassword:'',
              confirmPassword:''
            },
            rules:{
              newPassword:[{validator:validateNewPassword,trigger:'blur'}],
              confirmPassword:[{validator:validateConfirmPassword,trigger:'blur'}],
            },
            passwordPercent:0,
          }
      },
      created(){
        this.changePasswordForm.userName = window.sessionStorage.getItem('USER_NAME');
      },
      mounted(){
          this.query();
      },
      methods:{
        query:function(){
        },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$axios.post('/hlsTS/hlsii/user/changeUserPwd/'+ this.changePasswordForm.userName + '/' + this.changePasswordForm.oldPassword + '/' + this.changePasswordForm.newPassword).then((response) => {
                if(response.data.success== true){ 
                    this.$message(response.data.message);
                }else{
                    this.$message('Operation failed');
                }
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          let defaultUserForm = {
            userName:this.changePasswordForm.userName,
            oldPassword:'',
            newPassword:'',
            confirmPassword:''
          }
          this.changePasswordForm = Object.assign({},defaultUserForm);
        },
        passwordPercentFormat(percentage){
        if(percentage === 0){
          return '';
        }else if(percentage < 50){
          return '弱';
        }else if(percentage > 80){
          return '强';
        }else{
          return '中';
        }
      },
      customColorMethod(percentage){
        if(percentage < 50){
          return 'red'
        }else if(percentage > 80){
          return 'green'
        }else {
          return 'orange'
        }
      }
      }
    }

</script>

<style scope>
  .changePassword .el-form-item__label{width:150px;}
  .changePassword .el-form-item__content{margin-left:150px}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/changePassword.vue